module.exports = __webpack_public_path__ + "static/focusalignment-53613828c8c0602e05c8223391f391bc.png";